import Seo from "@/lib/Seo";
import { PageHead } from "@/pages/About";
import { BRAND } from "@/content/site";
import DiagnosticForm from "@/components/DiagnosticForm";

export default function Contact() {
  return (
    <>
      <Seo path="/contact" title="تواصل معنا" description="تواصل مع فريق سياق أو ابدأ تشخيص منظمتك." />
      <PageHead eyebrow="تواصل معنا" title="تواصل معنا" subtitle="نحن هنا لفهم سياقك وتصميم الحلول المناسبة لسياقك، تواصل معنا الآن" />
      <div className="bg-paper py-16">
        <div className="mx-auto max-w-[1100px] px-6 sm:px-10 grid lg:grid-cols-[1fr_1.4fr] gap-14">
          <div>
            <h2 className="font-display text-navy text-2xl">معلومات التواصل</h2>
            <a href={`mailto:${BRAND.email}`} className="mt-4 inline-block link-underline" style={{ color: "var(--coral)" }} data-testid="contact-email">{BRAND.email}</a>
            <div className="mt-8 flex flex-col gap-3">
              {BRAND.socials.map((s) => (
                <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer" className="text-blue hover:text-navy transition-colors" aria-label={s.label}>{s.label}</a>
              ))}
            </div>
          </div>
          <div>
            <h2 className="font-display text-navy text-2xl mb-6">ابدأ تشخيص منظمتك</h2>
            <DiagnosticForm />
          </div>
        </div>
      </div>
    </>
  );
}
